import { Injectable } from "@angular/core";
import {
    IAddress,
    IAddressWithTimeZone,
    ICoordinate,
    ILocation,
    LocationCreator,
    LocationUpdater,
} from "@ramudden/models/location";
import { Observable } from "rxjs";
import { ApiService } from "./api";

@Injectable({
    providedIn: "root",
})
export class LocationApi extends ApiService<ILocation, LocationCreator, LocationUpdater> {
    override getRoute(): string {
        return "Locations";
    }

    getAddressFromCoordinates$(coordinate: ICoordinate): Observable<IAddressWithTimeZone> {
        const url = `${super.getUrl()}/GetAddressFromCoordinates`;

        const params = {
            params: {
                latitude: coordinate.latitude.toString(),
                longitude: coordinate.longitude.toString(),
            },
        };

        return this.http.get<IAddressWithTimeZone>(url, params);
    }

    getCoordinatesFromAddress$(address: IAddress): Observable<ICoordinate> {
        const url = `${super.getUrl()}/GetCoordinatesFromAddress`;
        return this.http.post<ICoordinate>(url, address);
    }
}
